import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import object from '../../../common/object';
export default function (queryRoleResult, request) {
  var checkparam = queryRoleResult.checkparam,
      md5str = queryRoleResult.md5str,
      data = queryRoleResult.data;
  var map = object.unSerialize(data, 1);

  if (map._webplat_msg_code) {
    if (map._webplat_msg_code * 1 == 1) {
      return {
        iRet: 3,
        // 未查询到角色信息
        sMsg: '在该服务器上未获取到角色信息！',
        arrRole: null
      };
    }

    if (map._webplat_msg_code * 1 != 0) {
      return {
        iRet: 2,
        // 未查询到角色信息
        sMsg: '查询人数过多，请您稍后再来！',
        arrRole: null
      };
    }
  } // let roleId = LoginManager.getUserUin();
  // if(!roleId){
  // 	return null;
  // }


  var _arrRole = map._webplat_msg;

  if (!_arrRole) {
    return {
      iRet: 3,
      // 未查询到角色信息
      sMsg: '在该服务器上未获取到角色信息！',
      arrRole: null
    };
  }

  _arrRole = _arrRole.split('|').filter(function (item) {
    return item;
  });

  if (_arrRole.length == 1) {
    return {
      iRet: 3,
      // 未查询到角色信息
      sMsg: '在该服务器上未获取到角色信息！',
      arrRole: null
    };
  }

  var _arrRoleList = [];

  for (var i = 1; i < _arrRole.length; i++) {
    if (_arrRole[i]) {
      var _oneArray = _arrRole[i].split(' ');

      if (_oneArray.length >= 2) {
        try {
          _oneArray[1] = decodeURIComponent(_oneArray[1]);
        } catch (e) {
          console.log(e);
        }

        _arrRoleList.push(_objectSpread(_objectSpread({
          roleId: _oneArray[0],
          roleName: _oneArray[1]
        }, request), {}, {
          checkparam: checkparam,
          md5str: md5str
        }));
      }
    }
  }

  return {
    iRet: 0,
    // 查询到角色信息
    sMsg: 'OK',
    arrRole: _arrRoleList
  };
}